$(window).on("load", function () {
  if ($(".engagements").length) {
    $(".slider-ingredients").slick({
      infinite: true,
      arrows: true,
      variableWidth: false,
      slidesToShow: 4,
      nextArrow: ".engagement--right",
      responsive: [
        {
          breakpoint: 765,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          },
        }
      ],
    });
  }
});
